import { render } from "./transaction-item.vue?vue&type=template&id=07f6456c"
import script from "./transaction-item.vue?vue&type=script&lang=js"
export * from "./transaction-item.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__